import { getResponseData, getErrorMessage, post } from "../libs/http";
import { camelizeKeys } from "humps";

export function getRequestSummary(referralId) {
    return post(`/referrals/${referralId}/initial_request_summary/show`)
    .then(getResponseData())
    .then((res) => camelizeKeys(res))
    .catch(getErrorMessage());
  }